import React, { useState } from "react";
import axios from "axios";
import { Mail, ArrowRight } from "lucide-react";
import "./ForgotPasswordForm.css";
const API_URL = process.env.REACT_APP_API_URL;

const ForgotPasswordForm = ({ onBack, onSuccess }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");
    setLoading(true);

    try {
      const res = await axios.post(
        `${API_URL}/api/auth/forgot-password`,
        { email }
      );

      if (res.status === 200) {
        setSuccessMessage(
          "Password reset link has been sent to your email."
        );
        if (onSuccess) onSuccess(email);
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Failed to send reset link. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const forgotShowcaseBackground = {
    backgroundImage: "url('https://blackroth-images.s3.ap-south-1.amazonaws.com/forgetimage.png')",
  };

  return (
    <div className="forgot-component-container">
      <div className="auth-wrapper">

        {/* LEFT SIDE */}
        <div className="credentials-panel">
          <div className="forgot-copy-block">
            <h3>Forgot Password</h3>
            <p className="subtext">
              Enter your email to receive reset instructions
            </p>
          </div>

          <form onSubmit={handleSubmit} className="forgot-form">
            <div className="forgot-form-card">
              <div className="input-row">
                <Mail size={22} className="input-prefix-icon" />
                <input
                  className="field-input"
                  type="email"
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            {error && <p className="error-text">{error}</p>}
            {successMessage && (
              <p className="success-text">{successMessage}</p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="action-button"
            >
              {loading ? "Sending..." : "Send Reset Link"}
            </button>

            <button
              type="button"
              onClick={onBack}
              className="back-button"
            >
              Remembered your password? <span>Log in</span>
              <ArrowRight size={16} />
            </button>
          </form>
        </div>

        {/* RIGHT SIDE (UPDATED IMAGE HERE ✅) */}
        <div className="welcome-section" style={forgotShowcaseBackground}>
          <div className="showcase-overlay" />
          <div className="showcase-content">
            <h2>Secure Your Account</h2>
            <p>We&apos;ll help you reset your password safely.</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ForgotPasswordForm;
